__webpack_require__.p = "/ShortStories/";